import React, { Component } from 'react';
import _ from 'lodash';
import Immutable, {Range} from 'immutable';
import { firebaseRoot, snapshotToArray } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchButton from '../components/TouchButton';
import TouchLink from '../components/TouchLink';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const Dashboard = React.createClass({
    mixins: [ReactFireMixin],

	contextTypes: {
		userRef: React.PropTypes.object
	},

    getInitialState() {
        return {
            threeWorstMinusLessons: []
        }
    },

    fetchThreeWorstMinusLessons: async function() {
        const lessonPoints = snapshotToArray(await this.lessonsPointsRef.once('value'));
        const lessons = snapshotToArray(await this.lessonsRef.once('value'));
        const sortedByWorstMinusPoints = lessonPoints.sort(function(a,b){return (a['minus'] || 0) < (b['minus'] || 0)});
        while (sortedByWorstMinusPoints.length < 3) {
            sortedByWorstMinusPoints.push(_.sample(lessons))
        }
        const threeWorstMinusLessons = sortedByWorstMinusPoints.slice(0,3);
        return Promise.all(threeWorstMinusLessons.map(lesson => {
            return this.lessonsRef.child(lesson.key()).once("value");
        }));
    },

    componentWillMount() {
        this.lessonsPointsRef = firebaseRoot.child('userData').child(this.context.userRef.key()).child('points/lessons');
        this.lessonsRef = firebaseRoot.child('content/lessons');
        this.fetchThreeWorstMinusLessons().then(
            lessons => this.setState({threeWorstMinusLessons: lessons})
        );
	},

	render() {

		let tutorLink = '/bookrouter';

		/*if(this.context.userRef && this.context.userRef.val()) {
			tutorLink = `/book/${this.context.userRef.val().isbn}/chapters`;
		}*/

		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='dashboard'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<div className="dashboard-wrap">

						<section className="dashboard-section dashboard-profile">
							<div className="profile-img"></div>
							<h2 className="profile-name">
								<TouchLink to={(this.context.userRef && this.context.userRef.val()) ? '/profile' : '/login'} className="text-wrap">
									{(this.context.userRef && this.context.userRef.val()) ? this.context.userRef.val().email : "Inte inloggad"}
								</TouchLink>
							</h2>
							<div className="profile-tools">
								<TouchLink to="/"><Glyphicon glyph="question-sign"/></TouchLink>
							</div>
						</section>

						<section className="dashboard-section dashboard-level">
							<ul className="dashboard-level-list">
								<li className="level-item level--1 level--done">
									<div className="level-img"></div>
									<div className="level-bar"></div>
								</li>
								<li className="level-item level--2 level--done">
									<div className="level-img level--2"></div>
									<div className="level-bar"></div>
								</li>
								<li className="level-item level--3 level--current">
									<div className="level-img"></div>
									<div className="level-bar"></div>
								</li>
								<li className="level-item level--4">
									<div className="level-img"></div>
									<div className="level-bar"></div>
								</li>
								<li className="level-item level--5">
									<div className="level-img"></div>
									<div className="level-bar"></div>
								</li>
							</ul>
							<p className="level-next">30/49 points to next level</p>
						</section>

						<section className="dashboard-section dashboard-stats">
							<div className="stats-tests">
								<TouchLink className="brick">
									<span className="score">10 (8)</span>
									<span className="title">Tests</span>
								</TouchLink>
								<TouchLink className="brick">
									<span className="score">6</span>
									<span className="title">Favorites</span>
								</TouchLink>
							</div>
							<div className="stats-topics">
								<div className="brick topics-viewed">
									<span className="title">Topics viewed</span>
									<span className="score">8/50</span>
								</div>
								<div className="brick topics-graph">
									<span className="score">16%</span>
									<div className="graph"></div>
								</div>
							</div>
							<div className="stats-result">
								<div className="brick">
									<div className="content">
										<span className="title">You're <br/>good at</span>
										<span className="score">Algebra</span>
									</div>
									<div className="icon">
										<Glyphicon glyph="thumbs-up"/>
									</div>
								</div>
								<div className="brick">
									<div className="content">
										<span className="title">You need to <br/> improve in</span>
										<span className="score">Equation</span>
									</div>
									<div className="icon">
										<Glyphicon glyph="thumbs-down"/>
									</div>
								</div>
							</div>
						</section>

						<section className="dashboard-section dashboard-links">
							<div className="links-hero">
								<div className="links-hero-albert"></div>
								<TouchLink to={tutorLink} className="links-hero-link">
									<span className="icon"></span>
									<span className="title">Get tutored</span>
								</TouchLink>
							</div>
							<TouchLink to="/lesson" className="links-link">
								<span className="icon lesson"></span>
								<span className="title">Take a lesson</span>
							</TouchLink>
							<TouchLink to="/assessment" className="links-link">
								<span className="icon assessment"></span>
								<span className="title">Make assessment</span>
							</TouchLink>
						</section>

						<section className="dashboard-section dashboard-links dashboard-links-recommendations">
							<div className="header">Recommended exercises</div>
							<TouchLink className="links-link">
								<span className="icon"></span>
								<span className="title">Different ways to write a number</span>
							</TouchLink>
							<TouchLink className="links-link">
								<span className="icon"></span>
								<span className="title">Different ways to write a number</span>
							</TouchLink>
							<TouchButton className="links-show" bsStyle="link">Show more</TouchButton>
						</section>

						<section className="dashboard-section dashboard-links dashboard-links-recommendations">
							<div className="header">Recommended lessons</div>
                            {this.state.threeWorstMinusLessons.map((lesson, i) => {
                                return (
                                    <TouchLink className="links-link" key={i} to={`lesson/${lesson.key()}`}>
                                        <span className="icon"></span>
                                        <span className="title">{lesson.child('name').val()}</span>
                                    </TouchLink>
                                );
                            })}
							<TouchButton className="links-show" bsStyle="link">Show more</TouchButton>
						</section>
                        <section className="dashboard-section dashboard-links">
                            <TouchLink className="links-link" to="/login">
                                <span className="icon"></span>
                                <span className="title">Test link to login</span>
                            </TouchLink>
                        </section>
					</div>
				</div>
			</div>
		);
	}
});

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/screens/Dashboard.js
 **/